import { render } from "./Create-forever-club-card.vue?vue&type=template&id=4cc50c83"
import script from "./Create-forever-club-card.vue?vue&type=script&lang=js"
export * from "./Create-forever-club-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__